module.exports = __webpack_public_path__ + "static/media/discover.49e867de.png";